/**
 * What the shortcodes put in the page (src/WordPress/BookingBlocks.php): the block mount points, the payload
 * (window.papounanBooking: api, contact, display), the templates (window.papounanBookingI18n) and the labels
 * (hidden .pap-labels, translated by TranslatePress). Today is computed here in the site's time zone (payload
 * `timeZone`, WordPress Settings › General, 1.2.3), never taken from the page HTML (the page is cached at the edge).
 */
import { createI18n, readLabels } from './i18n.js';
import { initAnalytics } from './analytics.js';

export function readPage() {
	const lang = document.documentElement.lang || 'fr';
	const timeZone = window.papounanBooking?.timeZone;
	const nodes = [...document.querySelectorAll('.pap-block[data-pap-block]')];
	initAnalytics({ caps: window.papounanBooking?.analytics || null });
	return {
		nodes,
		payload: window.papounanBooking || null,
		i18n: createI18n(window.papounanBookingI18n || {}, lang, readLabels(document), window.papounanBooking?.labels || {}, timeZone),
		today: todayIn(timeZone),
		params: new URLSearchParams(window.location.search)
	};
}

/** Today (YYYY-MM-DD) in the site's time zone; throws without one (no built-in zone, 1.2.3). */
export function todayIn(timeZone) {
	if (!timeZone) {
		throw new Error('papounanBooking.timeZone missing');
	}
	return new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
}

/** The ONE API client of the page: window.PapounanApi, announced by `papounan:api-ready` (02 §9.2). */
export function publishApi(api) {
	window.PapounanApi = api;
	window.dispatchEvent(new CustomEvent('papounan:api-ready', { detail: api }));
	return api;
}
